<template>
  <div class="h-px w-full bg-[#E0E0E0] dark:bg-[#FDFDFD1F]" />
</template>
